/**
 * Referentials made of named items: fabric books and sewing patterns share the
 * screen, the dialog and the shape of their API.
 */
import type { QueryKey } from '@tanstack/react-query';
import { z } from 'zod';

export const namedItemSchema = z.object({ id: z.string(), name: z.string() });
export type NamedItem = z.infer<typeof namedItemSchema>;

export interface NamedItemService {
  /** Singular label used in the titles and messages ("fabric book"). */
  label: string;
  queryKey: QueryKey;
  list: () => Promise<NamedItem[]>;
  create: (name: string) => Promise<unknown>;
  update: (id: string, name: string) => Promise<unknown>;
  delete: (id: string) => Promise<unknown>;
}
